import { render, staticRenderFns } from "./giftCard.vue?vue&type=template&id=20fc4d68&scoped=true&"
import script from "./giftCard.vue?vue&type=script&lang=js&"
export * from "./giftCard.vue?vue&type=script&lang=js&"
import style0 from "./giftCard.vue?vue&type=style&index=0&id=20fc4d68&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20fc4d68",
  null
  
)

export default component.exports